import React from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

interface Props {
  onStartNewSequence: () => void;
}

const SequenceComplete: React.FC<Props> = ({ onStartNewSequence }) => {
  const handleStartNewSequence = async () => {
    try {
      // Reset the sequence
      await axios.post(`${BACKEND_URL}/api/sequence/reset`);
      // Start a new sequence
      await axios.post(`${BACKEND_URL}/api/sequence/start/1`);
      onStartNewSequence();
    } catch (error) {
      console.error('Error starting new sequence:', error);
    }
  };

  return (
    <div style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      color: 'white',
      padding: '30px',
      borderRadius: '15px',
      textAlign: 'center',
      zIndex: 1000,
      maxWidth: '500px',
      width: '90%'
    }}>
      <h1 style={{ marginBottom: '20px', color: '#28a745' }}>🎉 Sequence Completed! 🎉</h1>
      <p style={{ fontSize: '18px', marginBottom: '30px' }}>
        Congratulations! You've successfully completed the yoga sequence.
      </p>
      <button
        onClick={handleStartNewSequence}
        style={{
          padding: '12px 24px',
          fontSize: '16px',
          backgroundColor: '#28a745',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          transition: 'background-color 0.2s ease'
        }}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#218838'}
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#28a745'}
      >
        Start New Sequence
      </button>
    </div>
  );
};

export default SequenceComplete; 